import { Injectable } from '@angular/core'

@Injectable()

export class AlmacenesService {


  tabla = 'rest_almacenes';
  data = [];

  constructor(){

    this.data = JSON.parse(localStorage.getItem(this.tabla)) || [];

  }



  get(){

    return this.data;

  }



  set(data){

    this.data = data;
    localStorage.setItem(this.tabla, JSON.stringify(data));

    return this.data;

  }


  getByLocal(id){

    let aux = [];

    for(let item of this.data){

      if(item.id_local == id){

        aux.push(item);
      }
    }

    return aux;

  }


  delete(){

    this.data = null;
    localStorage.removeItem(this.tabla);

    return this.data;
  }

}



// WEBPACK FOOTER //
// ./src/services/AlmacenesService.ts